/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Powered_ByInputs */

const en_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Closed Caption Converter | www.closedcaptionconverter.com`)
};

const fr_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propulsé par Closed Caption Converter | www.closedcaptionconverter.com`)
};

const de_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitgestellt von Closed Caption Converter | www.closedcaptionconverter.com`)
};

const it_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizzato da Closed Caption Converter | www.closedcaptionconverter.com`)
};

const ru_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано с помощью программы для конвертации субтитров | www.closedcaptionconverter.com`)
};

const es_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollado por Closed Caption Converter | www.closedcaptionconverter.com`)
};

const zh_cn2_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Closed Caption Converter 提供技术支持 | www.closedcaptionconverter.com`)
};

const ja_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプションコンバーター搭載 | www.closedcaptionconverter.com`)
};

const hi_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन कन्वर्टर द्वारा संचालित | www.closedcaptionconverter.com`)
};

const pt_pt2_dialogue_list_export_powered_by = /** @type {(inputs: Dialogue_List_Export_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com tecnologia Closed Caption Converter | www.closedcaptionconverter.com`)
};

/**
* | output |
* | --- |
* | "Powered by Closed Caption Converter \| www.closedcaptionconverter.com" |
*
* @param {Dialogue_List_Export_Powered_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_powered_by = /** @type {((inputs?: Dialogue_List_Export_Powered_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Powered_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_powered_by(inputs)
	if (locale === "de") return de_dialogue_list_export_powered_by(inputs)
	if (locale === "it") return it_dialogue_list_export_powered_by(inputs)
	if (locale === "ru") return ru_dialogue_list_export_powered_by(inputs)
	if (locale === "es") return es_dialogue_list_export_powered_by(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_powered_by(inputs)
	if (locale === "ja") return ja_dialogue_list_export_powered_by(inputs)
	if (locale === "hi") return hi_dialogue_list_export_powered_by(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_powered_by(inputs)
	return en_dialogue_list_export_powered_by(inputs)
});